import { FormValidationService } from '../services/form-validation.service.js';

export function validateForm() {
  return function decorator(targetClass, fnName, fn) {
    const origFn = fn.value;
    fn.value = async function decorated(ev, ...args) {
      ev.preventDefault();
      const isValid = await FormValidationService.validateAllFields(ev.target);
      if (isValid) {
        await origFn.call(this, ev, ...args);
      }
    };
    return fn;
  };
}
